import { render, staticRenderFns } from "./BolgeEkle.vue?vue&type=template&id=58351eb6"
import script from "./BolgeEkle.vue?vue&type=script&lang=js"
export * from "./BolgeEkle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports